export const FREQUENCIE_INTERVAL_OPTIONS = [
  {
    label: 'Diário',
    value: 'DAYLE',
  },
  {
    label: 'Semanal',
    value: 'WEEKLY',
  },
  {
    label: 'Quinzenal',
    value: 'BIWEEKLY',
  },
  {
    label: 'Mensal',
    value: 'MONTHLY',
  },
  {
    label: 'Bimestral',
    value: 'BIMONTHLY',
  },

  {
    label: 'Trimestal',
    value: 'TRIMONTHLY',
  },
  {
    label: 'Semestral',
    value: 'SEMESTERLY',
  },
  {
    label: 'Anual',
    value: 'YEARLY',
  },
]
